import { render } from "./supply-chain-request-form.vue?vue&type=template&id=5c2b1500&scoped=true"
import script from "./supply-chain-request-form.vue?vue&type=script&lang=js"
export * from "./supply-chain-request-form.vue?vue&type=script&lang=js"

import "./_supply-chain-request-form.mobile.scss?vue&type=style&index=0&id=5c2b1500&lang=scss&scoped=true&external"
import "./_supply-chain-request-form.desktop.scss?vue&type=style&index=1&id=5c2b1500&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2b1500"]])

export default __exports__